export enum StudyProgramPeriodType {
  AcademicYear = 'ayp',
  Semester = 'sem',
  CalendarYear = 'cyp',
  ThreeSemester = 'sem3',
  Term = 'term',
}
